import {
  createNewCategoriesPath,
  createNewCategory,
  editCategoriesPath,
  getListCategoriesDetailItems,
  getListCategoriesItems,
  getListCategoriesParentPath,
  getListCategoriesPath,
  putCategoryItem,
  removeCategoriesPath,
} from "../constants/apiRoutes";

import apiService from "../utils/configAxios";
import { categoriesActions } from "../reducers/Admin/categoriesActions";
import { toast } from "react-toastify";
import apiServiceSecond from "../utils/configAxiosSecond";

export const fetchCreateNewCategories = (dataValues, navigate) => {
  return (dispatch) => {
    return apiServiceSecond
      .post(createNewCategory(), dataValues)
      .then((response) => {
        navigate("/adminManager/categories-list");
        toast.success("Uspešno ste dodali kategoriju", { theme: "colored" });
      })
      .catch((err) => {
        let errorMessage = err.response ? err.response.data.message : err;
        if (!err.response) {
          toast.error(
            "Greška, pokušajte da osvežite stranu pa ponovo pokušajte istu akciju.",
            { theme: "colored" }
          );
        }
        toast.error(errorMessage, { theme: "colored" });
      });
  };
};

export const fetchDeleteCategories = (pageId) => {
  return (dispatch) => {
    dispatch(categoriesActions.actionStart());
    return apiService
      .delete(removeCategoriesPath(pageId))
      .then((response) => {
        toast.success(response.data.message, { theme: "colored" });
        return apiService
          .get(getListCategoriesPath(0))
          .then((response) => {
            dispatch(categoriesActions.fetchAllPagesList(response.data));
          })
          .catch((err) => {
            let errorMessage = err.response ? err.response.data.message : err;
            if (!err.response) {
              toast.error(
                "Greška, pokušajte da osvežite stranu pa ponovo pokušajte istu akciju.",
                { theme: "colored" }
              );
            }
            toast.error(errorMessage, { theme: "colored" });
          });
      })
      .catch((err) => {
        let errorMessage = err.response ? err.response.data.message : err;
        if (!err.response) {
          toast.error(
            "Greška, pokušajte da osvežite stranu pa ponovo pokušajte istu akciju.",
            { theme: "colored" }
          );
        }
        toast.error(errorMessage, { theme: "colored" });
      });
  };
};

export const fetchEditCategories = (dataValues, navigate, id) => {
  return (dispatch) => {
    return apiServiceSecond
      .put(putCategoryItem(id), dataValues)
      .then((response) => {
        navigate("/adminManager/categories-list");
        toast.success("Uspešno ste azurirali kategoriju", { theme: "colored" });
      })
      .catch((err) => {
        let errorMessage = err.response ? err.response.data.message : err;
        if (!err.response) {
          toast.error(
            "Greška, pokušajte da osvežite stranu pa ponovo pokušajte istu akciju.",
            { theme: "colored" }
          );
        }
        toast.error(errorMessage, { theme: "colored" });
      });
  };
};

export const fetchCategoriesPagesList = (pageId = 0) => {
  return (dispatch) => {
    dispatch(categoriesActions.actionStart());
    return apiService
      .get(getListCategoriesPath(pageId))
      .then((response) => {
        if (pageId === 0)
          dispatch(categoriesActions.fetchAllPagesList(response.data));
        else dispatch(categoriesActions.fetchAllPagesDetail(response.data));
      })
      .catch((err) => {
        let errorMessage = err.response ? err.response.data.message : err;
        if (!err.response) {
          toast.error(
            "Greška, pokušajte da osvežite stranu pa ponovo pokušajte istu akciju.",
            { theme: "colored" }
          );
        }
        toast.error(errorMessage, { theme: "colored" });
      });
  };
};

export const fetchCategoriesPrentList = () => {
  return (dispatch) => {
    dispatch(categoriesActions.actionStart());
    return apiService
      .get(getListCategoriesParentPath())
      .then((response) => {
        dispatch(
          categoriesActions.fetchAllPagesParentCategoriesList(response.data)
        );
      })
      .catch((err) => {
        let errorMessage = err.response ? err.response.data.message : err;
        if (!err.response) {
          toast.error(
            "Greška, pokušajte da osvežite stranu pa ponovo pokušajte istu akciju.",
            { theme: "colored" }
          );
        }
        toast.error(errorMessage, { theme: "colored" });
      });
  };
};

export const fetchCategoriesListItems = () => {
  return (dispatch) => {
    dispatch(categoriesActions.actionStart());
    return apiServiceSecond
      .get(getListCategoriesItems())
      .then((response) => {
        dispatch(categoriesActions.fetchAllPagesList(response.data));
        dispatch(
          categoriesActions.fetchAllPagesParentCategoriesList(response.data)
        );
      })
      .catch((err) => {
        let errorMessage = err.response ? err.response.data.message : err;
        if (!err.response) {
          toast.error(
            "Greška, pokušajte da osvežite stranu pa ponovo pokušajte istu akciju.",
            { theme: "colored" }
          );
        }
        toast.error(errorMessage, { theme: "colored" });
      });
  };
};

export const fetchCategoriesDetailListItems = (id) => {
  return (dispatch) => {
    dispatch(categoriesActions.actionStart());
    return apiServiceSecond
      .get(getListCategoriesDetailItems(id))
      .then((response) => {
        dispatch(categoriesActions.fetchAllPagesDetail(response.data));
      })
      .catch((err) => {
        let errorMessage = err.response ? err.response.data.message : err;
        if (!err.response) {
          toast.error(
            "Greška, pokušajte da osvežite stranu pa ponovo pokušajte istu akciju.",
            { theme: "colored" }
          );
        }
        toast.error(errorMessage, { theme: "colored" });
      });
  };
};
